import { InputAdornment, TextField } from "@mui/material";
import styles from "./Home.module.css";
import { SearchOutlined } from "@mui/icons-material";
import InfoWidget from "../../../components/InfoWidget";
import MapView from "../../MapView";
import Table from "../../../components/Table";
import ProjectStatusCard from "../../../components/ProjectStatusCard";
import { LineChart } from "../../../widgets/HighCharts";
import {TopNavDash} from "../../../components/TopNav";
import ErrorBoundary from "../../../errorHandler/ErrorBoundary";
import Carousel2 from "../../../components/Carousel2";
import { useLocation } from "react-router-dom";
import { useContext, useEffect } from "react";
import DashboardContext from "../../../context/DashboardContext";

const boxInfo = [
    {
        iconUrl:"/assets/icons/drone.svg",
        label:"Active Missions",
        val:"02"
    },
    {
        iconUrl:"/assets/icons/task.svg",
        label:"Completed",
        val:"07"
    },
    {
        iconUrl:"/assets/icons/timer.svg",
        label:"Total Flight Hours",
        val:"115 Hrs"
    },
    {
        iconUrl:"/assets/icons/survey.svg",
        label:"Area Surveyed",
        val:"34 km"
    },
    {
        iconUrl:"/assets/icons/location-on-map.svg",
        label:"Processed Maps",
        val:"22"
    }
]

const Home = () => {
    const location = useLocation();
    const {popupImage, setPopupImage,setControlTabIndex} = useContext(DashboardContext)
    useEffect(()=>{
        console.log(location.pathname.split("/"))
        setControlTabIndex(0)
    },[])
    return (
        <div className={styles.homeContainer}>
            {/* search bar */}
            <TopNavDash />
            {/* widgets */}
            <div className={styles.widgets}>
                {
                    boxInfo.map(info=> <InfoWidget key={info.iconUrl} icon={info.iconUrl} label={info.label} val={info.val} />)
                }
            </div>
            {/* table and map */}
            <div className={styles.tableMap}>
                <div className={`${styles.tableContainer} hideScrollbar smooth-scroll`}>
                    <Table />
                </div>
                <div className={styles.mapContainer}>
                    <ErrorBoundary>
                        <MapView />
                    </ErrorBoundary>
                </div>
            </div>
            {/* carousel and dashboard */}
            <div className={styles.endRow}>
                <div style={{padding:"10px 0"}}>
                    {/* <ImageCarousel /> */}
                    <Carousel2 />
                </div>
                <div>
                    <div>
                        <ProjectStatusCard/>
                    </div>
                    <div>
                        <LineChart type="line" />
                        <LineChart type="bar" />
                    </div>
                </div>
            </div>
            {popupImage && (
        <div className={styles.popupoverlay} onClick={() => setPopupImage(null)}>
          <div className={styles.popupcontent} onClick={(e) => e.stopPropagation()}>
            <img src={popupImage} alt="expanded" />
          </div>
        </div>
      )}
        </div>
    );
};

export default Home;
